import { render, staticRenderFns } from "./PollResultsTable.vue?vue&type=template&id=943aadc4&scoped=true"
import script from "./PollResultsTable.vue?vue&type=script&lang=js"
export * from "./PollResultsTable.vue?vue&type=script&lang=js"
import style0 from "./PollResultsTable.vue?vue&type=style&index=0&id=943aadc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943aadc4",
  null
  
)

export default component.exports